module.exports = __webpack_public_path__ + "img/lang-29.0321450c.jpg";